<template>
  <div class="program">
    <ul class="programlist">
      <li v-for="item in videos" :class="{live:item.status==1}">
        <div class="time">
          {{item.vidCreateTime | format}}
        </div>
        <div class="name">
          <span>{{item.teacherName}}</span>
          {{item.name}}
        </div>
        <div class="back" @click="goplay2(item.activeId)">观看</div>
      </li>
    </ul>
  </div>
</template>

<script>
import * as api from "../../../api/api";
import moment from "moment";

export default {
  name: "Vods",
  props: ['rid'],
  data() {
    return {
      videos: [],
    }
  },
  filters: {
    format: function (value) {
      return moment(parseInt(value)*1000).format("MM-DD HH:mm");
    },
    strFormat: function (value) {
      return value.slice(0,4)
    }
  },
  created() {
    this.gethis()
  },
  methods: {
    gethis: function () {
      //获取设置的行情问题列表
      this.$http.get(api.HIS + this.rid).then(function (data) {
        this.videos = data.body.data;
      })
    },
    goplay2: function (activeId) {
      this.$emit("ActiveId",activeId)
    },
    setHeight: function () {
      var totalheight = parseFloat($(window).height());
      var headerheight = parseFloat($('.navtab').height());
      var homeheight = totalheight - headerheight
      var videoheight = parseFloat($('.zbj').height());
      var tabheigt = parseFloat($('.tab').height());
      // var commentheight = homeheight - videoheight - tabheigt;
      // console.log(commentheight)
      var liveheight = parseFloat($('.liveprompt').height());
      var commentheight = homeheight - videoheight - tabheigt - liveheight;
      $('.program').height(commentheight);
    }
  },
  mounted() {
    this.setHeight();
    window.onresize = function () {
      this.setHeight();
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/zb/components/Vods.vue